import Vue from 'vue';
import Router from 'vue-router';

import HelloWorld from '@/components/HelloWorld';

import Login from '@/pages/Login';

import Home from '@/pages/Home';
import Inicio from '@/pages/Inicio';
import TesteExtrato from '@/pages/TesteExtrato';

import ClientesLista from '@/pages/clientes/ClientesLista';
import ClientesForm from '@/pages/clientes/ClientesForm';

import PedidosLista from '@/pages/pedidos/PedidosLista';
import PedidosForm from '@/pages/pedidos/PedidosForm';

import FornecedoresLista from '@/pages/fornecedores/FornecedoresLista';
import FornecedoresForm from '@/pages/fornecedores/FornecedoresForm';
import ProdutosFornecedor from '@/pages/fornecedores/ProdutosFornecedor';

import VendedoresLista from '@/pages/vendedores/VendedoresLista';
import VendedoresForm from '@/pages/vendedores/VendedoresForm';

import UsuariosLista from '@/pages/usuarios/UsuariosLista';
import UsuariosForm from '@/pages/usuarios/UsuariosForm';
import UsuariosPermissoes from '@/pages/usuarios/UsuariosPermissoes';
import UsuariosProfile from '@/pages/usuarios/UsuariosProfile';

import RepresentantesLista from '@/pages/representantes/RepresentantesLista';
import RepresentantesForm from '@/pages/representantes/RepresentantesForm';

import ChequesLista from '@/pages/cheques/ChequesLista';
import ChequesForm from '@/pages/cheques/ChequesForm';

import CaixaLista from '@/pages/caixa/CaixaLista';
import CaixaForm from '@/pages/caixa/CaixaForm';

import ContasAReceberLista from '@/pages/contasareceber/ContasAReceberLista';
import RecebimentoPromissorias from '@/pages/contasareceber/RecebimentoPromissorias';

import RecebimentosLista from '@/pages/recebimentos/RecebimentosLista';
import RecebimentosListaForm from '@/pages/recebimentos/RecebimentosListaForm';

import ExtratoCliente from '@/pages/extratocliente/ExtratoCliente';

import Relatorios from '@/pages/relatorios/Relatorios';

import Configuracoes from '@/pages/Configuracoes';

import NaoEncontrado from '@/pages/404';
import Chat from '@/pages/Chat';

import Auth from '@/app/plugins/Auth';

import LotesRoutes from './lotes';
import LojasRoutes from './lojas';
import ProdutosRoutes from './produtos';
import PedidosCompraRoutes from './pedidoscompra';
import VariacoesRoutes from './variacoes';
import GruposRoutes from './grupos';
import SistemaRoutes from './sistema';
import PDVRoutes from './pdv';
import ContasPagarRoutes from './contaspagar';

import { guards } from './guards.js';

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    console.log('scrollBehavior');
    return { x: 0, y: 0 };
  },

  routes: [
    ...LotesRoutes,
    ...LojasRoutes,
    ...ProdutosRoutes,
    ...PedidosCompraRoutes,
    ...VariacoesRoutes,
    ...GruposRoutes,
    ...SistemaRoutes,
    ...PDVRoutes,
    ...ContasPagarRoutes,

    { path: '/i/:m', name: 'Inicio', component: Inicio, props: true },

    {
      path: '/cadastros/fornecedores',
      name: 'FornecedoresLista',
      component: FornecedoresLista,
    },
    {
      path: '/cadastros/fornecedores/adicionar',
      name: 'FornecedoresAdicionar',
      component: FornecedoresForm,
    },
    {
      path: '/cadastros/fornecedores/:id/editar',
      name: 'FornecedoresEditar',
      component: FornecedoresForm,
      meta: { editando: true },
    },
    {
      path: '/cadastros/fornecedores/:id/produtos',
      name: 'ProdutosFornecedor',
      component: ProdutosFornecedor,
    },

    {
      path: '/cadastros/vendedores',
      name: 'VendedoresLista',
      component: VendedoresLista,
    },
    {
      path: '/cadastros/vendedores/adicionar',
      name: 'VendedoresAdicionar',
      component: VendedoresForm,
    },
    {
      path: '/cadastros/vendedores/:id/editar',
      name: 'VendedoresEditar',
      component: VendedoresForm,
      meta: { editando: true },
    },

    {
      path: '/sistema/usuarios',
      name: 'UsuariosLista',
      component: UsuariosLista,
      meta: { permissao: 'usuarios:acessar' },
    },
    {
      path: '/sistema/usuarios/adicionar',
      name: 'UsuariosAdicionar',
      component: UsuariosForm,
      meta: { permissao: 'usuarios:criar' },
    },
    {
      path: '/sistema/usuarios/:id/editar',
      name: 'UsuariosEditar',
      component: UsuariosForm,
      meta: { permissao: 'usuarios:editar' },
      meta: { editando: true },
    },

    {
      path: '/sistema/permissoes',
      name: 'UsuariosPermissoes',
      component: UsuariosPermissoes,
      meta: { permissao: 'usuarios:permissoes' },
    },

    {
      path: '/perfil',
      name: 'UsuariosProfile',
      component: UsuariosProfile,
    },

    {
      path: '/cadastros/representantes',
      name: 'RepresentantesLista',
      component: RepresentantesLista,
    },
    {
      path: '/cadastros/representantes/adicionar',
      name: 'RepresentantesAdicionar',
      component: RepresentantesForm,
    },
    {
      path: '/cadastros/representantes/:id/editar',
      name: 'RepresentantesEditar',
      component: RepresentantesForm,
      meta: { editando: true },
    },

    {
      path: '/cadastros/clientes',
      name: 'ClientesLista',
      component: ClientesLista,
    },
    {
      path: '/cadastros/clientes/adicionar',
      name: 'ClientesAdicionar',
      component: ClientesForm,
    },
    {
      path: '/cadastros/clientes/:id/editar',
      name: 'ClientesEditar',
      component: ClientesForm,
      meta: { editando: true },
    },

    {
      path: '/vendas/pedidos',
      name: 'PedidosLista',
      component: PedidosLista,
    },
    {
      path: '/vendas/pedidos/adicionar',
      name: 'PedidosAdicionar',
      component: PedidosForm,
    },
    {
      path: '/vendas/pedidos/:id/editar',
      name: 'PedidosEditar',
      component: PedidosForm,
      meta: { editando: true },
    },
    {
      path: '/vendas/pedidos/:id/copiar',
      name: 'PedidosCopiar',
      component: PedidosForm,
      meta: { copiando: true },
    },

    {
      path: '/cheques/controle',
      name: 'ChequesLista',
      component: ChequesLista,
    },
    {
      path: '/cheques/controle/adicionar',
      name: 'ChequesAdicionar',
      component: ChequesForm,
    },
    {
      path: '/cheques/controle/:id/editar',
      name: 'ChequesEditar',
      component: ChequesForm,
      meta: { editando: true },
    },

    {
      path: '/financeiro/caixa',
      name: 'CaixaLista',
      component: CaixaLista,
    },
    {
      path: '/financeiro/caixa/adicionar',
      name: 'CaixaAdicionar',
      component: CaixaForm,
    },
    {
      path: '/financeiro/caixa/:id/editar',
      name: 'CaixaEditar',
      component: CaixaForm,
      meta: { editando: true },
    },

    {
      path: '/financeiro/contasareceber',
      name: 'ContasAReceberLista',
      component: ContasAReceberLista,
    },

    {
      path: '/financeiro/contasareceber/recebimento',
      name: 'RecebimentoContasAReceber',
      component: RecebimentoPromissorias,
    },

    {
      path: '/financeiro/recebimentos',
      name: 'RecebimentosLista',
      component: RecebimentosLista,
    },

    {
      path: '/financeiro/extratocliente',
      name: 'ExtratoCliente',
      component: ExtratoCliente,
    },
    {
      path: '/financeiro/extratocliente/recebimento',
      name: 'RecebimentoPromissorias',
      component: RecebimentoPromissorias,
    },

    {
      path: '/relatorios',
      name: 'Relatorios',
      component: Relatorios,
    },

    {
      path: '/financeiro/testeextrato',
      name: 'TesteExtrato',
      component: TesteExtrato,
    },

    {
      path: '*',
      meta: {
        public: true,
      },
      redirect: {
        path: '/404',
      },
    },
  ],
});

router.beforeEach(guards);

// router.beforeEach((to, from, next) => {
//   // let api_token = window.localStorage.getItem('organize.token');
//   // let api_token = Auth.getToken();

//   if (to.meta.public) {
//     next();
//   } else {
//     if (Auth.check()) {
//       next();
//     } else {
//       next("/login");
//     }
//   }
// });

export default router;
